// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".link[data-v-a00db392] {\n  cursor: pointer;\n}\nfooter[data-v-a00db392] {\n  color: var(--footerElementsFontColor, white);\n  font-family: var(--footerElementsFontTypeface, inherit);\n  font-weight: var(--footerElementsFontWeight, inherit);\n}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
